import { FAQ } from "../FAQ/index";
import InlineLink from "../inlineLink";

const DataIHaveIdeasSlackLink = () => (
  <InlineLink href={"https://oceanxmedia.slack.com/archives/C0374D6THLN"}>
    #data-i-have-ideas
  </InlineLink>
);

export const Explanations = () => {
  const copy = [
    {
      title: "How do you calculate transect length?",
      content: (
        <>
          <p>
            We take the ROV position logged with SeaLog every 15 seconds, and
            project the latitude and longitude to UTM coordinates. We then
            calculate the distance between each pair of consecutive positions,
            and sum these distances to get the total length of the transect.
          </p>
        </>
      ),
    },
    {
      title: "What is Density?",
      content: (
        <>
          <p>
            Density is the percentage of the length of the ROV transect that was
            classified by the AI as containing at least one organism of the
            specified phylum.
          </p>
          <br />
          <p>
            We calculate the % of the length by taking the start and end
            position of a section detected as containing the Phylum, and then
            projecting the latitude and longitude of the ROV to UTM coordinates.
            We then calculate the distance between the start and end position,
            and then calculate the percentage of the total length of the
            transect that this section represents.
          </p>
        </>
      ),
    },
    {
      title: "What is Occurrence?",
      content: (
        <>
          <p>
            For a specific Phylum, <i>occurrence</i> is the percentage of video
            frames that were detected by the AI as containing at least one
            organism of that Phylum.
          </p>
          <br />
          <p>
            Occurrence is calculated over the entire ROV dive, including the
            descent and ascent across the water column.
          </p>
        </>
      ),
    },
    {
      title: <p>How does the underlying AI technology work?</p>,
      content: (
        <>
          <p>
            We use a state-of-the-art model developed and open-sourced by
            Microsoft Research,{" "}
            <InlineLink href={"https://imageomics.github.io/bioclip/"}>
              BioCLIP
            </InlineLink>
            , as the foundation for detecting corals and sponges in deep-sea ROV
            videos.
          </p>
          <br />
          <p>
            BioCLIP is an extension of the{" "}
            <InlineLink href={"https://openai.com/research/clip"}>
              CLIP model
            </InlineLink>
            , developed by OpenAI. CLIP is a <i>multimodal model</i>. This means
            that it can integrate different types of data, in this case both
            visual (the ROV video) and textual data (the taxonomic labels).
            Similar to how AI tools like ChatGPT can understand both text and
            images, BioCLIP is designed to process visual data while drawing on
            a vast knowledge of the{" "}
            <InlineLink
              href={"https://en.wikipedia.org/wiki/Tree_of_Life_(biology)"}
            >
              Tree of Life taxonomy
            </InlineLink>
            . It has been trained on 10 million images representing a wide range
            of species, enabling it to identify organisms and their taxonomical
            relationships with high accuracy.
          </p>
          <br />
          <p>
            To predict Coral and Sponges presence, we process all videos of each
            ROV dive. Every 5 seconds, we extract a frame from the video feed
            and input it into the BioCLIP model. The model analyzes the frame
            and returns the five most likely phyla present, along with a
            confidence score for each.
          </p>
          <br />
          <p>
            To determine whether the frame contains sponges or corals, we apply
            a filtering step. We discard any classifications with confidence
            scores below a predetermined threshold. Then, if either{" "}
            <i>Porifera</i> (sponges) or <i>Cnidaria</i> (corals) appears among
            the shortlisted phyla, the frame is classified as containing the
            respective organisms.
          </p>
        </>
      ),
    },
  ];
  return <FAQ copy={copy} />;
};
